/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExcelAnalysisVo
 */
export interface ExcelAnalysisVo {
    /**
     * 表头
     * @type {Array<string>}
     * @memberof ExcelAnalysisVo
     */
    headers?: Array<string>;
    /**
     * 数据
     * @type {Array<Array<string>>}
     * @memberof ExcelAnalysisVo
     */
    data?: Array<Array<string>>;
}

/**
 * Check if a given object implements the ExcelAnalysisVo interface.
 */
export function instanceOfExcelAnalysisVo(value: object): value is ExcelAnalysisVo {
    return true;
}

export function ExcelAnalysisVoFromJSON(json: any): ExcelAnalysisVo {
    return ExcelAnalysisVoFromJSONTyped(json, false);
}

export function ExcelAnalysisVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcelAnalysisVo {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'] == null ? undefined : json['headers'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ExcelAnalysisVoToJSON(json: any): ExcelAnalysisVo {
    return ExcelAnalysisVoToJSONTyped(json, false);
}

export function ExcelAnalysisVoToJSONTyped(value?: ExcelAnalysisVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'],
        'data': value['data'],
    };
}

